import { format, isSameDay } from 'date-fns'

export const getDateWithoutTZ = (date: string): Date => {
  const dateNoZ = date.replace('Z', '')
  const newDate = new Date(dateNoZ)

  // validate date
  if (Number.isNaN(newDate.getTime())) {
    throw new Error('Invalid date')
  }
  return newDate
}

export const formatDateTime = (startDate: string, endDate: string): string => {
  const start = getDateWithoutTZ(startDate)
  const end = getDateWithoutTZ(endDate)

  const formattedDays = isSameDay(start, end)
    ? format(start, 'd MMM yyyy')
    : `${format(start, 'd MMM')} - ${format(end, 'd MMM yyyy')}`

  const formattedTime = `${format(start, 'h:mma')} - ${format(end, 'h:mma')}`

  return `${formattedDays} | ${formattedTime}`
}

export const formatDate = (
  startDate: string | undefined,
  endDate: string | undefined,
): string => {
  const start = startDate && getDateWithoutTZ(startDate)
  const end = endDate && getDateWithoutTZ(endDate)

  let formattedDays = ''

  if (start && end) {
    formattedDays = isSameDay(start, end)
      ? format(start, 'd MMM yyyy')
      : `${format(start, 'd MMM')} - ${format(end, 'd MMM yyyy')}`
  }

  if (start && !end) {
    formattedDays = format(start, 'd MMM yyyy')
  }

  if (!start && end) {
    formattedDays = format(end, 'd MMM yyyy')
  }

  return `${formattedDays}`
}

export const formatTime = (startDate: string, endDate: string): string => {
  const start = getDateWithoutTZ(startDate)
  const end = getDateWithoutTZ(endDate)

  const formattedTime = `${format(start, 'h:mma')} - ${format(end, 'h:mma')}`

  return `${formattedTime}`
}
